import { Grid } from '@material-ui/core';
import { VerticalMenu } from 'components/VerticalMenu/VerticalMenu';
import * as React from 'react';
import { ActivityLog } from './ActivityLog';
import { Calls } from './Calls';
import { Deals } from './Deals';
import { Meetings } from './Meetings';
import { Notes } from './Notes';
import { Vacancies } from './Vacancies';
import { Tickets } from './Tickets';
import { News } from './News';
import { ClientNpsView } from './Nps';
import { useLocation, useHistory } from 'react-router-dom';

enum ActivityTabs {
  LOG = 'log',
  CALLS = 'calls',
  MEETINGS = 'meetings',
  TICKETS = 'tickets',
  VACANCIES = 'vacancies',
  DEALS = 'deals',
  NOTES = 'notes',
  NEWS = 'news',
  NPS = 'nps',
}

export const Activity: React.FC<{
  companyId: string;
  withRelated: boolean;
  meetingNotes?: string;
  hasKonnektOrJim: boolean;
  hasZendesk: boolean;
  hasZendeskSupport: boolean;
}> = ({
  companyId,
  withRelated,
  meetingNotes,
  hasKonnektOrJim,
  hasZendesk,
  hasZendeskSupport,
}) => {
  const location = useLocation();
  const history = useHistory();

  const getInitialTab = () => {
    const hash = location.hash.replace('#', '');
    const validTabs = Object.values(ActivityTabs);
    return validTabs.includes(hash as ActivityTabs)
      ? (hash as ActivityTabs)
      : ActivityTabs.LOG;
  };

  const [selectedTab, setSelectedTab] = React.useState<string>(getInitialTab());

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    history.push(`${location.pathname}#${tab}`);
  };

  const tabs = [
    { label: 'Activity Log', value: ActivityTabs.LOG },
    { label: 'Calls', value: ActivityTabs.CALLS },
    { label: 'Meetings', value: ActivityTabs.MEETINGS },
    { label: 'Vacancies', value: ActivityTabs.VACANCIES },
    { label: 'Support Tickets', value: ActivityTabs.TICKETS },
    { label: 'Deals', value: ActivityTabs.DEALS },
    { label: 'Notes', value: ActivityTabs.NOTES },
    { label: 'News', value: ActivityTabs.NEWS },
    { label: 'NPS', value: ActivityTabs.NPS },
  ];

  return (
    <Grid container>
      <Grid item xs={12} sm={2}>
        <VerticalMenu
          menuItems={tabs}
          selectedItemKey={selectedTab}
          setSeletedItemKey={handleTabChange}
        />
      </Grid>
      <Grid item xs={12} sm={10}>
        {getCurrentTab()}
      </Grid>
    </Grid>
  );

  function getCurrentTab() {
    switch (selectedTab) {
      case ActivityTabs.LOG:
        return <ActivityLog companyId={companyId} withRelated={withRelated} />;
      case ActivityTabs.CALLS:
        return (
          <Calls
            companyId={companyId}
            withRelated={withRelated}
            hasZendesk={hasZendesk}
          />
        );
      case ActivityTabs.MEETINGS:
        return <Meetings companyId={companyId} withRelated={withRelated} />;
      case ActivityTabs.VACANCIES:
        return (
          <Vacancies
            companyId={companyId}
            withRelated={withRelated}
            hasKonnektOrJim={hasKonnektOrJim}
          />
        );
      case ActivityTabs.TICKETS:
        return (
          <Tickets
            companyId={companyId}
            withRelated={withRelated}
            hasZendeskSupport={hasZendeskSupport}
          />
        );
      case ActivityTabs.DEALS:
        return (
          <Deals
            companyId={companyId}
            withRelated={withRelated}
            hasZendesk={hasZendesk}
          />
        );
      case ActivityTabs.NOTES:
        return (
          <Notes
            companyId={companyId}
            withRelated={withRelated}
            meetingNotes={meetingNotes}
          />
        );
      case ActivityTabs.NEWS:
        return <News companyId={companyId} />;
      case ActivityTabs.NPS:
        return <ClientNpsView companyId={companyId} />;
      default:
        return null;
    }
  }
};
